import { Helper } from '../Helper';
export class GetOutputAssetValueMapHelper extends Helper {
    emit(sb, node, optionsIn) {
        sb.emitOp(node, 'NEWMAP');
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, optionsIn, sb.helpers.mergeAssetValueMaps({
            add: true,
        }));
    }
}

//# sourceMappingURL=GetOutputAssetValueMapHelper.js.map
